import React, { useEffect, useState } from "react";
import axios from "axios";
import { Row, Col, Modal, Form, Button, OverlayTrigger, } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { MdEdit, MdFilterList, MdSwapHoriz, MdHistory } from "react-icons/md";
import { Tooltip } from "@mui/material";
import { ToastContainer } from "react-toastify";
import FeesScheduleApi from "../feeitemschedule/FeesScheduleApi ";
import loading from "../../assets/images/common/loading.gif";
import { useFeeModuleAccess } from "../hooks/useFeeModuleAccess";
import AppDataGrid from '../../components/common/AppDataGrid';

const Feesstudentsschedule = () => {
    const userData = sessionStorage.getItem("user");
    const userObj = userData ? JSON.parse(userData) : {};
    const userIdStr = userObj.school_id;
    const userId = parseInt(userIdStr, 10);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const [classes, setClass] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isSavingSchedule, setIsSavingSchedule] = useState(false);

    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [feesTerms, setFeesTerms] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [selectedClassId, setSelectedClassId] = useState(null);
    const [showScheduleModal, setShowScheduleModal] = useState(false);
    const [showScheduleTypeModal, setShowScheduleTypeModal] = useState(false);
    const [scheduletypes, setScheduletypes] = useState([]);
    const [selectedStudentId, setSelectedStudentId] = useState(null);

    const [selectedFeeScheduleTypeId, setSelectedFeeScheduleTypeId] = useState("");
    const [scheduleApiParams, setScheduleApiParams] = useState({});
    const [scheduleDetails, setScheduleDetails] = useState([]);
    const [feesTermsChild, setFeesTermsChild] = useState([]);
    const [baseFeesTerms, setBaseFeesTerms] = useState([]);
    const [students, setStudents] = useState([]);

    const currentUserRole = userObj.role_name?.trim();
    const { canWrite } = useFeeModuleAccess(currentUserRole);

    // initial load - only fee data
    useEffect(() => {
        setIsLoading(true);
        fetchData().finally(() => setIsLoading(false));
    }, []);

    // when filter modal OR schedule modal opens, load classes + students
    useEffect(() => {
        if (showFilterModal) {
            fetchclasses(userId);
            fetchStudents();
        }
    }, [showFilterModal, showScheduleModal]);

    const fetchscheduletypes = async (schoolId) => {
        try {
            const response = await axios.post(baseUrl + "/feescheduletype/", {
                action: "READ",
                school_id: schoolId
            });

            const filterData = Array.isArray(response.data) ? response.data : [];
            const activeTypes = filterData.filter(
                item => item.is_active?.toLowerCase() === 'active'
            );

            setScheduletypes(activeTypes);
        } catch (error) {
            console.error("Error fetching schedule types:", error);
        }
    };


    const handleOpenScheduleModal = (row) => {
        setSelectedClassId(row.class_id);
        setSelectedStudentId(row.student_id);
        setShowScheduleModal(true);
        fetchscheduletypes(userObj.school_id);
    };

    const fetchStudents = async () => {
        try {
            const response = await axios.post(baseUrl + "/students/", {
                action: "READ",
                school_id: userObj.school_id
            });
            const filterData = Array.isArray(response.data) ? response.data : [];

            const filteredStudents = filterData.filter(
                item => item.status?.toLowerCase() === 'active'
            );
            setStudents(filteredStudents);
        } catch (error) {
            console.error("Error fetching students:", error);
        }
    };

    const fetchData = async () => {
        try {
            const response = await axios.post(baseUrl + "/getfeestudentstructure/", {
                p_school_id: userObj.school_id,
                p_academic_year_id: userObj.academic_year_id,
            });

            const filterData = Array.isArray(response.data) ? response.data : [];

            const filteredParent = filterData.filter(
                (item) => item.category?.toLowerCase() === "class total"
            );
            setFeesTerms(filteredParent);
            setBaseFeesTerms(filteredParent);

            const filteredChild = filterData.filter(
                (item) => item.category?.toLowerCase() !== "class total"
            );
            setFeesTermsChild(filteredChild);

        } catch (error) {
            console.error("Error fetching Fees items:", error);
        }
    };

    const fetchclasses = async (userId) => {
        try {
            const response = await axios.post(baseUrl + "/classes/", {
                action: "READ",
                school_id: userId,
            });
            const filterData = Array.isArray(response.data) ? response.data : [];

            const filteredClasses = filterData.filter(
                (item) => item.is_active?.toLowerCase() === "active"
            );
            setClass(filteredClasses);
        } catch (error) {
            console.error("Error fetching classes:", error);
        }
    };

    const [filter, setFilter] = useState({
        class_id: 0,
        student_id: 0,
    });

    const handleFilterSubmit = async (e) => {
        e.preventDefault();

        const filteredData = baseFeesTerms.filter(term =>
            (String(filter.class_id) === "0" || !filter.class_id ? true : String(term.class_id) === String(filter.class_id)) &&
            (String(filter.student_id) === "0" || !filter.student_id ? true : String(term.student_id) === String(filter.student_id))
        );

        if (filteredData.length === 0) {
            setFeesTerms([]);
        } else {
            setFeesTerms(filteredData);
        }
        setShowFilterModal(false);
    };

    const handleFilterReset = async () => {
        setFilter({
            fee_schedule_id: "",
            amount_to_pay: "",
            academic_year_id: "",
            class_id: "",
            fees_item_id: "",
            student_id: ""
        });

        setShowFilterModal(true);
        fetchData();
    }

    const handleSearchChange = (event) => {
        setFilter({
            fee_schedule_id: "",
            amount_to_pay: "",
            academic_year_id: "",
            class_id: "",
            fees_item_id: "",
        });
        setSearchQuery(event.target.value);
    };

    const searchableColumns1 = [
        (row) => row.admission_number,
        (row) => row.class_name,
        (row) => row.fees_item,
        (row) => row.total_amount,
        (row) => row.student_name,
    ];

    const extractTermKeys = (data) => {
        const termKeys = new Set();
        data.forEach((item) => {
            Object.keys(item).forEach((key) => {
                if (key.toLowerCase().includes("term") || key.toLowerCase().includes("others")) {
                    termKeys.add(key);
                }
            });
        });
        return Array.from(termKeys).sort();
    };

    const termKeys = extractTermKeys(feesTerms);

    const dynamicTermColumns = termKeys.map((term) => ({
        name: term.split(" (")[0],
        selector: (row) => row[term],
        cell: (row) => (
            <Tooltip title={row[term]}>
                <span>{row[term]}</span>
            </Tooltip>
        ),
        sortable: true,
    }));
    const fetchScheduleDetails = async (student_id) => {
        try {
            const res = await axios.post(baseUrl + "/getfeestudentschedule/", {
                school_id: userObj.school_id,
                academic_year_id: userObj.academic_year_id,
                student_id,
            });
            console.log(res.data);
            setScheduleDetails(res.data || []);
        } catch (err) {
            console.error("Error loading schedule details:", err);
        }
    };
    const handleTotalClick = (student_id) => {

        fetchScheduleDetails(student_id);
        setShowScheduleTypeModal(true);
    };

    const trimmedQuery1 = searchQuery.trim().toLowerCase();
    const filteredRecords1 =
        trimmedQuery1.length > 0
            ? (feesTerms || []).filter((feesTerms) =>
                searchableColumns1.some((selector) => {
                    const value = selector(feesTerms);
                    return String(value || "")
                        .toLowerCase()
                        .includes(trimmedQuery1);
                })
            )
            : feesTerms || [];

    const columnsFeesItemGrid = [
        {
            field: 'admission_number',
            headerName: 'Admission Number',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            renderCell: (params) =>
                filteredRecords1.length > 0 ? (
                    <Tooltip title={params.value}>
                        <span>{params.value}</span>
                    </Tooltip>
                ) : (
                    <div className="noDataMessage">No Records Found</div>
                ),
        },
        {
            field: 'student_name',
            headerName: 'Student Name',
            width: 150, // similar to your width: "150px"
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <div
                        style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            width: '100%',
                        }}
                    >
                        {params.value}
                    </div>
                </Tooltip>
            ),
        },
        {
            field: 'class_name',
            headerName: 'Class',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: 'total',
            headerName: 'Total Amount',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span
                        className="hyperlink"
                        style={{ color: 'green', cursor: 'pointer' }}
                        onClick={() => handleTotalClick(params.row.student_id)}
                    >
                        {params.value}
                    </span>
                </Tooltip>
            ),
        },
        ...(canWrite
            ? [
                {
                    field: 'actions',
                    headerName: 'Actions',
                    flex: 1,
                    headerAlign: 'center',
                    align: 'center',
                    sortable: false,
                    renderCell: (params) =>
                        filteredRecords1.length > 0 ? (
                            <div className="tableActions" style={{ display: 'flex', gap: 10 }}>
                                <Tooltip title="Edit" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleEditClick(params.row.student_id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <MdEdit />
                                    </span>
                                </Tooltip>
                                <Tooltip title="Previous Year Amount" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handlePreviousYearClick(params.row.student_id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <MdHistory />
                                    </span>
                                </Tooltip>
                                <Tooltip title="Change Schedule" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleOpenScheduleModal(params.row)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <MdSwapHoriz />
                                    </span>
                                </Tooltip>
                            </div>
                        ) : null,
                },
            ]
            : []),
    ];


    const handleEditClick = (student_id) => {
        const feesToEdit = feesTerms.find(
            (feesTerms) =>
                feesTerms.student_id === student_id
        );

        if (feesToEdit) {
            const updatedFeesToEdit = {
                ...feesToEdit,
                academic_year_id: userObj.academic_year_id,
            };

            navigate("/addfeesstudentsschedule", {
                state: {
                    discountsData: updatedFeesToEdit,
                },
            });
        } else {
            console.error(`Student with ID ${student_id} not found.`);
        }
    };

    const handlePreviousYearClick = (student_id) => {
        const feesToEdit = feesTerms.find(
            (feesTerms) =>
                feesTerms.student_id === student_id
        );

        if (feesToEdit) {
            const updatedFeesToEdit = {
                ...feesToEdit,
                academic_year_id: userObj.academic_year_id,
            };

            navigate("/addfeesstudentsschedule", {
                state: {
                    discountsData: updatedFeesToEdit,
                    isPreviousYearMode: true
                },
            });
        } else {
            console.error(`Student with ID ${student_id} not found.`);
        }
    };

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: "#EAE4E4",
                color: "#757575",
                fontSize: "14px",
                textAlign: "center",
            },
            className: "commonTH",
        },
        cells: {
            style: {
                fontSize: "14px",
            },
            className: "commonTD",
        },
        rows: {
            style: (row) => ({
                fontWeight: row.class_name === "Total:" ? "bold" : "normal",
                backgroundColor: row.class_name === "Total:" ? "#f0f0f0" : "transparent",
            }),
        },
    };
    const scheduleColumnsGrid = [
        {
            field: 'schedule_name',
            headerName: 'Schedule Name',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: 'amount',
            headerName: 'Amount',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: 'due_date',
            headerName: 'Due Date',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sortable: true,
            renderCell: (params) => (
                <Tooltip title={params.value}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
        },
    ];

    return (





        <div className="pageBody">
            <ToastContainer />
            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">
                            Fees Discount ({userObj.academic_year_name})
                        </h6>

                    </div>
                    <div className="">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}
                        >
                            <Button
                                className="secondaryBtn"
                                variant="secondary"
                                onClick={handleShowFilterModal}
                            >
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            rows={filteredRecords1.length ? filteredRecords1 : []}
                            columns={columnsFeesItemGrid}
                            getRowId={(row) => row.student_id}
                            pageSizeOptions={[10, 20, 50]}
                            showToolbar={false}
                            pagination
                            density="compact"
                            maxHeight={550}
                        />

                    )}
                </div>
            </div>
            <Modal
                show={showScheduleModal}
                onHide={() => setShowScheduleModal(false)}
                size="xl"
                centered
                dialogClassName="wideModal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Change Schedule</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Row className="mb-3">
                            <Col xs={12} md={6} lg={4} xxl={3}>
                                <div className='commonInput'>
                                    <Form.Group>
                                        <Form.Label>Schedule Type</Form.Label>
                                        <select
                                            className="form-select"
                                            id="fee_schedule_type_id"
                                            value={selectedFeeScheduleTypeId}
                                            onChange={(e) => {
                                                const newScheduleTypeId = e.target.value;
                                                setSelectedFeeScheduleTypeId(newScheduleTypeId);

                                                if (!newScheduleTypeId) {
                                                    // clear
                                                    setScheduleApiParams({});
                                                    return;
                                                }


                                                setScheduleApiParams({
                                                    p_academic_year_id: userObj.academic_year_id,
                                                    p_class_id: selectedClassId,
                                                    p_fee_schedule_type_id: newScheduleTypeId,
                                                    p_school_id: userObj.school_id
                                                });
                                            }}
                                            required
                                        >
                                            <option value="">Select Schedule</option>
                                            {scheduletypes.map((sct) => (
                                                <option
                                                    key={sct.fee_schedule_type_id}
                                                    value={sct.fee_schedule_type_id}
                                                >
                                                    {sct.fee_schedule_type_name}
                                                </option>
                                            ))}
                                        </select>
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                    {scheduleApiParams?.p_fee_schedule_type_id && (
                        <FeesScheduleApi
                            p_academic_year_id={scheduleApiParams.p_academic_year_id}
                            p_class_id={scheduleApiParams.p_class_id}
                            p_fee_schedule_type_id={scheduleApiParams.p_fee_schedule_type_id}
                            p_school_id={scheduleApiParams.p_school_id}
                            readOnly={true}
                        />
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setShowScheduleModal(false);
                            setSelectedFeeScheduleTypeId("");
                            setScheduleApiParams({});
                            setSelectedStudentId(null);
                        }}
                    >
                        Close
                    </Button>

                    <Button
                        variant="primary"
                        disabled={!selectedFeeScheduleTypeId}
                        onClick={async () => {
                            if (!selectedFeeScheduleTypeId || !selectedStudentId) {
                                alert("Please select a Schedule Type and ensure Student ID is present.");
                                return;
                            }

                            try {
                                const payload = {
                                    student_id: selectedStudentId,
                                    fee_schedule_type_id: selectedFeeScheduleTypeId,
                                    school_id: userObj.school_id,
                                    // academic_year_id:userObj.academic_year_id
                                };

                                console.log("Submitting payload:", payload);

                                await axios.post(`${baseUrl}/schedulechange/`, payload);

                                alert("Schedule updated successfully!");

                                setShowScheduleModal(false);
                                setSelectedFeeScheduleTypeId("");
                                setScheduleApiParams({});
                                setSelectedStudentId(null);
                            } catch (error) {
                                console.error("Error submitting schedule:", error);
                                alert("Failed to update schedule.");
                            }
                        }}
                    >
                        Submit
                    </Button>
                </Modal.Footer>

            </Modal>
            <Modal show={showScheduleTypeModal} onHide={() => setShowScheduleTypeModal(false)} size="xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Schedule Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AppDataGrid
                        rows={Array.isArray(scheduleDetails) ? scheduleDetails : []}
                        columns={scheduleColumnsGrid}
                        getRowId={(row, idx) => row.schedule_id ?? `${row.schedule_name || 'row'}-${idx}`}
                        pageSizeOptions={[10, 20, 50]}
                        showToolbar={false}
                        pagination
                        density="compact"
                        maxHeight={350}
                    />

                </Modal.Body>
            </Modal>
            <Modal
                show={showFilterModal}
                onHide={handleCloseFilterModal}
                className="commonFilterModal"
            >
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Form id="filterForm" onSubmit={handleFilterSubmit}>
                        <Row>
                            <Col xs={12}>
                                <div className="commonInput">
                                    <Form.Group>
                                        <Form.Label>Class</Form.Label>
                                        <select
                                            className="form-select"
                                            id="class_id"
                                            value={filter.class_id}
                                            onChange={(e) => {
                                                const selectedClassId = e.target.value;
                                                setFilter({ ...filter, class_id: selectedClassId });

                                                if (selectedClassId) {
                                                    const filtered = students.filter(
                                                        (stu) => String(stu.class_id) === String(selectedClassId)
                                                    );
                                                    setFilteredStudents(filtered);
                                                } else {
                                                    setFilteredStudents(students);
                                                }
                                            }}
                                        >
                                            <option value="">Select Class</option>
                                            {(classes || []).map((classe) => (
                                                <option key={classe.class_id} value={classe.class_id}>
                                                    {classe.class_name}
                                                </option>
                                            ))}
                                        </select>
                                    </Form.Group>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div className="commonInput">
                                    <Form.Group>
                                        <Form.Label>Student Name</Form.Label>
                                        <select
                                            className="form-select"
                                            id="student_id"
                                            value={filter.student_id}
                                            onChange={(e) =>
                                                setFilter({
                                                    ...filter,
                                                    student_id: e.target.value,
                                                })
                                            }
                                        >
                                            <option value="0">Select Student Name</option>
                                            {(filteredStudents || []).map((student) => (
                                                <option
                                                    key={student.student_id}
                                                    value={student.student_id}
                                                >
                                                    {student.student_first_name} {student.student_last_name}
                                                </option>
                                            ))}
                                        </select>
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button
                        variant="secondary"
                        className="btn-info clearBtn me-2"
                        onClick={handleFilterReset}
                    >
                        Reset
                    </Button>
                    <div>
                        <Button
                            variant="secondary"
                            className="btn-danger secondaryBtn me-2"
                            onClick={handleCloseFilterModal}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            className="primaryBtn"
                            form="filterForm"
                            onClick={handleCloseFilterModal}
                        >
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>



    );
}

export default Feesstudentsschedule